import AttendAchievementLayoutOutput from './AttendAchievementLayoutOutput';

export default AttendAchievementLayoutOutput;
